import { ButtonType } from "@components/Button/types";
import { Overlay } from "@components/Overlay";
import { OverlayProps } from "@components/Overlay/types";
import { useErrorBanner, useModal, useRemovePartnerFromGoal } from "@hooks";
import { i18n, Translations } from "@i18n";
import { RemoveContributorModalProps } from "./types";

export const RemoveContributorModal = ({
  name,
  partnerId,
  goalId,
}: RemoveContributorModalProps) => {
  const { dismiss } = useModal();
  const { showErrorBanner } = useErrorBanner();

  const [removePartner, { loading }] = useRemovePartnerFromGoal();

  const handleRemove = async () => {
    try {
      await removePartner({
        variables: {
          partnerId,
          goalId,
        },
      });
    } catch {
      showErrorBanner();
    } finally {
      dismiss();
    }
  };

  const props: OverlayProps = {
    title: i18n.t(Translations.RemoveContributorModalTitle, { name }),
    subtitle: i18n.t(Translations.RemoveContributorModalSubtitle),
    cta: {
      primary: {
        title: i18n.t(Translations.RemoveContributorModalPrimaryCTA),
        onClick: handleRemove,
        type: ButtonType.Danger,
        loading,
      },
      secondary: {
        title: i18n.t(Translations.RemoveContributorModalSecondaryCTA),
        onClick: dismiss,
      },
    },
    horizontal: true,
  };

  return <Overlay {...props} />;
};
